import React, { useRef, useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationErrors';

import logoImg from '../../assets/logo.svg';

import Button from '../../components/Button';
import Input from '../../components/Form/Input';

import {
  Container,
  Heading,
  RecoveryLink,
  TransparentButton,
  Warning,
} from './styles';

interface SignInData {
  email: string;
  password: string;
}

const SignIn: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const { signIn } = useAuth();
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        setLoading(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('Informe um email.')
            .email('Informe um email válido.'),
          password: Yup.string().required('Informe a senha.'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({
          email: data.email,
          senha: data.password,
        });

        history.push('/');
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
          return;
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: err?.response?.data?.message || 'Algo deu errado!',
        });
      } finally {
        setLoading(false);
      }
    },
    [signIn, addToast, history],
  );

  return (
    <Container>
      <Heading>
        <img alt="e-Bov" src={logoImg} />
      </Heading>

      <Form ref={formRef} style={{ width: '100%' }} onSubmit={handleSubmit}>
        <Input label="Email" name="email" type="email" />
        <Input label="Senha" name="password" type="password" />

        <Link to="/recuperar">
          <RecoveryLink>Esqueceu a senha?</RecoveryLink>
        </Link>

        <Button type="submit" isLoading={loading}>
          Entrar
        </Button>

        <Link to="/cadastro">
          <TransparentButton>
            Não tem uma conta?<b>Cadastre-se</b>
          </TransparentButton>
        </Link>
      </Form>

      {/*  <Warning>
        <img alt="e-Bov" src={logoImg} />

        <h2>Desculpe o inconveniente.</h2>
        <p>
          A plataforma está em manutenção programada. O sistema voltará a
          funcionar normalmente em <b>20/03/2022</b> às <b>09:00</b>.
        </p>
      </Warning> */}
    </Container>
  );
};

export default SignIn;
